import Phaser from 'phaser';

export class Star extends Phaser.GameObjects.Sprite {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 'star');
    scene.add.existing(this);
    this.setDisplaySize(52, 52).setDepth(12).setScale(0.1);
  }

  emerge(onComplete: () => void): void {
    this.scene.tweens.add({ targets: this, y: this.y - 84, scale: 1, angle: 360, duration: 620, ease: 'Back.out', onComplete });
    this.scene.tweens.add({ targets: this, alpha: { from: 0.8, to: 1 }, yoyo: true, repeat: 4, duration: 100 });
  }
}
